import { useMutationBuilder } from "src/query/useBuilders";
import { dealRoomMentionsSearchApiService } from "src/services/settings/dealRoomMentionsSearch";
import {
  DealRoomMentionsSearchRequest,
  DealRoomMentionsSearchResponse,
} from "src/types/settings/dealRoomMentionsSearch";
import { DEAL_ROOM_MENTIONS_SEARCH } from "../queryKeys";

export const useDealRoomMentionsSearch = () => {
  return useMutationBuilder<
    DealRoomMentionsSearchResponse,
    DealRoomMentionsSearchRequest
  >(
    [DEAL_ROOM_MENTIONS_SEARCH],
    (payload) => dealRoomMentionsSearchApiService.searchDealRoomMentions(payload)
  );
};
